import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=02437d3f&"
import script from "./upload-file.vue?vue&type=script&lang=js&"
export * from "./upload-file.vue?vue&type=script&lang=js&"
import style0 from "./upload-file.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-file.vue"
export default component.exports